import { mapKeys } from 'lodash';
// Analytics is defined as a global variable in the .erb head
// eslint-disable-next-line no-undef
const isAnalyticsAvailable = () => !!analytics;

const toCamel = str => (
  str.replace(/([-_][a-z])/ig, subStringToReplace => (
    subStringToReplace.toUpperCase().replace('-', '').replace('_', '')
  ))
);

const mapKeysToCamelCase = obj => mapKeys(obj, (v, k) => toCamel(k));

export const identify = (userId, traits) => {
  if (isAnalyticsAvailable()) {
    if (userId) {
      analytics.identify(userId, traits); // eslint-disable-line
    } else {
      analytics.identify(traits); // eslint-disable-line
    }
  }
};

// Don't default properties here as it falls back to the canonical url
export const trackPageView = (category, name, properties, callback) => {
  if (isAnalyticsAvailable()) {
    analytics.page(category, name, mapKeysToCamelCase(properties), {}, callback); // eslint-disable-line
  }
};

export const trackEvent = (event, properties = {}, callback) => {
  if (isAnalyticsAvailable()) {
    // Empty hash is options (e.g. what tools to integrate with specifically, not needed for now)
    analytics.track(event, mapKeysToCamelCase(properties), {}, callback); // eslint-disable-line
  }
};

// Categories
export const WEPLOYEE = 'weployee';
export const WEPLOYER = 'weployer';

// Pages
export const BANKING_DETAILS = 'banking_details';
export const DASHBOARD = 'dashboard';
export const JOBS = 'jobs';
export const FAQ = 'faq';
export const LOGIN = 'login';
export const PROFILE = 'profile';
export const SELECT_SHORTLIST = 'select_shortlist';
export const SELECT_CHECKOUT = 'select_checkout';
export const TIMESHEETS = 'timesheets';
export const PROFILE_HIRE_FORM = 'profile_hire_form';
export const SEARCH = 'search';

// Events

// Login
export const LOGIN_SUCCESS = 'login_success';

// Profile
export const PROFILE_ADD_BUTTON_CLICK = 'profile_add_button_click';
export const PROFILE_EDIT_BUTTON_CLICK = 'profile_edit_button_click';
export const PROFILE_FORM_SUBMIT_SUCCESS = 'profile_form_submit_success';
export const PROFILE_FORM_SUBMIT_ERROR = 'profile_form_submit_error';
export const PROFILE_CHECKLIST_COMPLETE = 'profile_checklist_complete';

// Banking details
export const BANKING_DETAILS_SUBMIT_SUCCESS = 'banking_details_submit_success';

// Select
export const SELECT_SHORTLISTED_WEPLOYEE_ACCEPT = 'select_shortlisted_weployee_accept';
export const SELECT_WEPLOYEE_PROFILE_VIEW = 'select_weployee_profile_view';
export const SELECT_WEPLOYEE_SUMMARY_SELECT = 'select_weployee_summary_select';
export const SELECT_WEPLOYEE_SUMMARY_DESELECT = 'select_weployee_summary_deselect';
export const SELECT_JOB_REPOST = 'select_job_repost';

// Jobs
export const OWNER_FILTER_CHANGE = 'owner_filter_change';

// Dashboard
export const NOTIFICATION_CLICK = 'notification_click';
export const NOTIFICATION_ACTION_BUTTON_CLICK = 'notification_action_button_click';
export const NOTIFICATION_DISMISS = 'notification_dismiss';
export const NOTIFICATION_ONBOARDING_NEXT_CLICK = 'notification_onboarding_next_click';
export const NOTIFICATION_ONBOARDING_OPEN = 'notification_onboarding_open';
export const NOTIFICATION_ONBOARDING_CLOSE = 'notification_onboarding_close';

// Timesheets
export const EXPORT_TIMESHEETS_BUTTON_CLICK = 'export_timesheets_button_click';
export const EXPORT_TIMESHEETS_SELECT_ALL_CLICK = 'export_timesheets_select_all_click';
export const TIMESHEETS_APPROVE_BUTTON_CLICK = 'timesheets_approve_button_click';
export const TIMESHEETS_BACK_BUTTON_CLICK = 'timesheets_back_button_click';
export const TIMESHEETS_BACK_TO_TIMESHEETS_BUTTON_CLICK = 'timesheets_back_to_timesheets_button_click';
export const TIMESHEETS_BILLING_DETAILS_CLICK = 'timesheets_billing_details_click';
export const TIMESHEETS_CONFIRM_BUTTON_CLICK = 'timesheets_confirm_button_click';
export const TIMESHEETS_COUPON_SELECT = 'timesheets_payment_term_select';
export const TIMESHEETS_PAYMENT_TERM_SELECT = 'timesheets_coupon_select';
export const TIMESHEETS_QUERY_EMAIL_CLICK = 'timesheets_query_email_click';
export const TIMESHEETS_SELECT_ALL_CLICK = 'timesheets_select_all_click';
export const TIMESHEETS_SKILL_INVOICE_OPEN = 'timesheets_skill_invoice_open';
export const TIMESHEETS_SUMMARY_MODAL_OPEN = 'timesheets_summary_modal_open';
export const TIMESHEETS_SUBMITTED_TAB_CLICK = 'timesheets_submitted_tab_click';
export const TIMESHEETS_APPROVED_TAB_CLICK = 'timesheets_approved_tab_click';
export const TIMESHEETS_DEEP_LINK_OPEN = 'timesheets_deep_link_open';

// Profile hire
export const WEPLOYEE_PROFILE_SEND_JOB_CLICK = 'weployee_profile_send_job_click';
export const PROFILE_HIRE_POST_JOB_CLICK = 'profile_hire_post_job_click';
export const PROFILE_HIRE_VIEW_WEPLOYEE_PROFILE_CLICK = 'profile_hire_view_weployee_profile_click';
export const PROFILE_HIRE_POST_TO_ALL_WEPLOYEES_CLICK = 'profile_hire_post_to_all_weployees_click';

// Search
export const SEARCH_PERFORM = 'search_perform';
export const SEARCH_SEND_JOB_CLICK = 'search_send_job_click';
export const SEARCH_PROFILE_SUMMARY_CLICK = 'search_profile_summary_click';

export default {
  identify,
  trackPageView,
  trackEvent,
};
/* eslint no-undef: 1 */
